import { UserStateType } from './state'

export interface UserGettersType {
  getUserById: (state: UserStateType) => UserStateType['user']
  getCompanyById: (state: UserStateType) => (id: string) => UserStateType['companies'][number] | undefined
  getAllCompanies: (state: UserStateType) => UserStateType['companies']
  getCompanyByCode: (state: UserStateType) => (code: string) => UserStateType['companies'][number] | undefined
}

export const UserGetters = {
  getUserById: (state: UserStateType) => state.user,
  getCompanyById: (state: UserStateType) => (id: string) => {
    return state.companies.find(company => company.id === id)
  },
  getAllCompanies: (state: UserStateType) => state.companies,
  getCompanyByCode: (state: UserStateType) => (code: string) => {
    return state.companies.find(company => company.code === code)
  },
}
